import {useCallback, useEffect, useState} from "react";
import {Outlet, useNavigate} from "react-router";
import {apiGet, isUserAdmin} from "../utils";

export const AdminLayout = () => {
    const navigate = useNavigate();
    const [shouldRender, setShouldRender] = useState(false);
    const [currentLeague, setCurrentLeague] = useState({});
    const [currentSeason, setCurrentSeason] = useState({});
    const [currentAuction, setCurrentAuction] = useState({});

    const fetchCurrentLeague = () => {
        apiGet(`league/current`, (data) => {
            setCurrentLeague(data.data ? data.data : {});
        });
    };

    const fetchCurrentSeason = () => {
        apiGet(`season/current`, (data) => {
            setCurrentSeason(data.data ? data.data : {});
        });
    };

    const fetchCurrentAuction = () => {
        apiGet(`auction/current`, (data) => {
            setCurrentAuction(data.data ? data.data : {});
        });
    };

    const refreshLeagueMetadata = useCallback(() => {
        fetchCurrentLeague();
        fetchCurrentSeason();
        fetchCurrentAuction();
    }, []);

    useEffect(() => {
        refreshLeagueMetadata();
    }, [refreshLeagueMetadata]);

    useEffect(() => {
        if (isUserAdmin()) {
            setShouldRender(true);
        } else {
            navigate('/rosters');
        }
    }, [navigate]);

    return (
        shouldRender ? <div><Outlet context={{currentLeague, currentSeason, currentAuction, refreshLeagueMetadata}}/></div> : <div/>
    );
};
